import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Box,
  Card,
  BottomNavigation,
  BottomNavigationAction,
  Avatar,
} from "@mui/material";
import {
  Notifications as NotificationsIcon,
  Chat as ChatIcon,
  AccountCircle as AccountCircleIcon,
  CalendarToday as CalendarTodayIcon,
  Payment as PaymentIcon,
  Home as HomeIcon,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";

const App = () => {
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [totalPayer, setTotalPayer] = useState(0);
  const navigate = useNavigate();

  const baseUrl = process.env.REACT_APP_APP_URL;

  const handleNavigateToNotifications = () => {
    navigate("/notifications");
  };

  const handleLogout = () => {
    localStorage.removeItem("CC_Token");
    localStorage.removeItem("user");
    toast.success("Vous avez été déconnecté avec succès.", {
      position: "top-right",
      autoClose: 3000,
    });
    setTimeout(() => navigate("/login"), 4000);
  };

  const token = localStorage.getItem("CC_Token");
  const user = JSON.parse(localStorage.getItem("user"));
  const userId = user ? user.id : null;

  useEffect(() => {
    const fetchInvoices = async () => {
      if (!token || !userId) {
        console.error("Erreur : Token ou ID utilisateur manquant.");
        setLoading(false);
        return;
      }

      try {
        const response = await axios.get(
          `${baseUrl}/api/invoices/user/${userId}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        const invoices = response.data.invoices;
        const formattedPayments = invoices.map((invoice) => ({
          date: new Date(invoice.created_at).toLocaleDateString(),
          invoice_number: invoice.invoice_number.toUpperCase(),
          amount: parseFloat(invoice.amount),
          method: invoice.status.toUpperCase(),
        }));

        setPayments(formattedPayments);

        const totalPayer = invoices
          .filter((invoice) => invoice.status.toLowerCase() === "à payer")
          .reduce((sum, invoice) => sum + parseFloat(invoice.amount), 0);

        const totalAcompte = invoices
          .filter((invoice) => invoice.status.toLowerCase() === "acompte")
          .reduce((sum, invoice) => sum + parseFloat(invoice.amount), 0);

        setTotalPayer(totalPayer - totalAcompte);
      } catch (error) {
        console.error("Erreur lors de la récupération des factures :", error);
      } finally {
        setLoading(false);
      }
    };

    fetchInvoices();
  }, [token, userId]);
  const handleProfile = () => {
    navigate("/Profile");
  };
  return (
    <div className="app" style={{ display: "flex", flexDirection: "column", height: "100vh" }}>
      {/* Header */}
      <AppBar position="fixed" sx={{ backgroundColor: "#003366" }}>
        <Toolbar>
          <Avatar
            alt="Logo"
            src={"../assets/cej.png"}
            sx={{ width: 40, height: 40, marginRight: "0.5rem" }}
          />
          <Typography
            variant="h6"
            sx={{
              flexGrow: 1,
              fontSize: { xs: "1rem", sm: "1.25rem" },
              color: "#ffffff",
            }}
          >
            Club Équestre Jafoura
          </Typography>
          <IconButton color="inherit" onClick={handleNavigateToNotifications}>
            <NotificationsIcon />
          </IconButton>
          <IconButton color="inherit" onClick={handleProfile}>
            <AccountCircleIcon />
          </IconButton>
          <IconButton color="inherit" onClick={handleLogout}>
            <ExitToAppIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      {/* Contenu principal */}
      <Box
        sx={{
          flex: 1,
          overflowY: "auto",
          marginTop: "64px", // Hauteur du header
          marginBottom: "56px", // Hauteur du footer
          padding: "1rem",
          backgroundColor: "#f5f5f5",
        }}
      >
        <Typography
          sx={{
            fontSize: "1.5rem",
            fontWeight: "bold",
            color: "#003366",
            marginBottom: "0.5rem",
          }}
        >
          Total à payer: {totalPayer.toFixed(2)} DT
        </Typography>
        <Box sx={{ marginBottom: "0.75rem" }}>
  <Typography
    sx={{
      fontSize: "0.85rem",
      color: "#003366",
      lineHeight: "1.3",
    }}
  >
    Mode de paiement : Espèce ou sur le RIB bancaire :
  </Typography>
  <Typography
    sx={{
      fontSize: "0.85rem",
      color: "#003366",
      lineHeight: "1.3",
    }}
  >
     08-702-0004340102830-54
  </Typography>
</Box>

        {loading ? (
          <Typography>Chargement des paiements...</Typography>
        ) : payments.length > 0 ? (
          payments.map((payment, index) => (
            <Card
              key={index}
              sx={{
                marginBottom: "1rem",
                padding: "1rem",
                borderRadius: "10px",
                backgroundColor: "#ffffff",
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography sx={{ fontSize: "0.9rem", color: "#555555" }}>
                  Date : {payment.date}
                </Typography>
                <Typography sx={{ fontSize: "0.9rem", color: "#555555" }}>
                  Description: {payment.invoice_number}
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography
                  sx={{ fontSize: "1.1rem", fontWeight: "600", color: "#007bff" }}
                >
                  {payment.amount.toFixed(2)} DT
                </Typography>
                <Typography
                  sx={{
                    fontSize: "0.8rem",
                    fontWeight: "500",
                    color: "#28a745",
                    textTransform: "uppercase",
                  }}
                >
                  {payment.method}
                </Typography>
              </Box>
            </Card>
          ))
        ) : (
          <Typography>Aucun paiement trouvé.</Typography>
        )}
      </Box>

      {/* Footer */}
      <BottomNavigation
        sx={{
          position: "fixed",
          bottom: 0,
          width: "100%",
          backgroundColor: "#003366",
        }}
      >
        <BottomNavigationAction
          label="Calendrier"
          icon={<CalendarTodayIcon sx={{ fontSize: 30, color: "#ffffff" }} />}
          onClick={() => navigate("/emploi")}
        />
        <BottomNavigationAction
          label="Accueil"
          icon={<HomeIcon sx={{ fontSize: 30, color: "#ffffff" }} />}
          onClick={() => navigate("/home")}
        />
        <BottomNavigationAction
          label="Paiement"
          icon={<PaymentIcon sx={{ fontSize: 30, color: "#ffffff" }} />}
          onClick={() => navigate("/payment")}
        />
      </BottomNavigation>
    </div>
  );
};

export default App;